/**
 * @langchain/core <= 1.1.48 crashes AIMessage construction when
 * response_metadata.output_version === 'v1' and content is a string
 * (contentBlocks.push is not a function). Coerce string content to
 * text blocks (or drop the v1 flag) before the SDK parses messages.
 */
function coerceContentBlocks(content) {
  if (Array.isArray(content)) return content;
  if (typeof content === 'string') {
    return content ? [{ type: 'text', text: content }] : [];
  }
  if (content == null) return [];
  return [content];
}

function normalizeMessage(msg) {
  if (!msg || typeof msg !== 'object') return;

  const meta = msg.response_metadata || msg.kwargs?.response_metadata;
  const content =
    msg.content !== undefined ? msg.content : msg.kwargs?.content;

  if (meta && meta.output_version === 'v1' && !Array.isArray(content)) {
    const blocks = coerceContentBlocks(content);
    if (msg.kwargs) {
      msg.kwargs.content = blocks;
      if (msg.kwargs.response_metadata) {
        msg.kwargs.response_metadata = {
          ...msg.kwargs.response_metadata,
        };
        delete msg.kwargs.response_metadata.output_version;
      }
    } else {
      msg.content = blocks;
      msg.response_metadata = { ...meta };
      delete msg.response_metadata.output_version;
    }
  }

  // Serialized LangChain messages sometimes nest under data / kwargs
  if (msg.data) normalizeMessage(msg.data);
  if (msg.kwargs && msg.kwargs !== msg) {
    // already handled content above; walk nested message lists if any
  }
}

function walk(value, seen = new Set()) {
  if (!value || typeof value !== 'object') return;
  if (seen.has(value)) return;
  seen.add(value);

  if (Array.isArray(value)) {
    value.forEach(item => {
      normalizeMessage(item);
      walk(item, seen);
    });
    return;
  }

  // Likely a message object
  if (
    value.type === 'ai' ||
    value.type === 'AIMessage' ||
    value.type === 'AIMessageChunk' ||
    value.id?.includes?.('AIMessage')
  ) {
    normalizeMessage(value);
  }

  Object.values(value).forEach(child => walk(child, seen));
}

export function normalizeLangChainPayload(payload) {
  walk(payload);
  return payload;
}
